const start = () => {
  try {
    if (!window.jQuery.rails) {
      const Rails = require('rails-ujs');
      Rails.start();
    }
  } catch (e) {
    //swallow error in case it's called twice
  }
};

document.addEventListener('DOMContentLoaded', () => {
  start();
});
